const FILE_SOURCES = {
  GOOGLE: 'google',
  DROPBOX: 'dropbox',
  BOX: 'box',
};

const FILE_MAX_SIZE_ALLOWED = 10240;

export {
  FILE_SOURCES,
  FILE_MAX_SIZE_ALLOWED
};
